import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterListIcon from '@mui/icons-material/FilterList';
import type { SxProps, Theme } from '@mui/material/styles';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import { SEARCE_COLORS } from '../../theme';

/** Shared size for table header filter icons (lines + funnel). */
export const COLUMN_HEADER_FILTER_ICON_FONT_SIZE = '0.8125rem';

export type ColumnHeaderFilterIconProps = SvgIconProps & {
  isFilterActive: boolean;
  /**
   * `onPrimary`: white list icon; warning funnel when a filter is applied (blue primary headers).
   * `inherit`: same size; color follows parent (e.g. IconButton on light gray headers).
   */
  variant?: 'onPrimary' | 'inherit';
};

/**
 * Idle: `FilterList`; when a column filter is applied: `FilterAlt` (funnel).
 * Default styling matches blue table headers; use `variant="inherit"` on neutral headers.
 */
export default function ColumnHeaderFilterIcon({
  isFilterActive,
  variant = 'onPrimary',
  sx,
  fontSize: _ignoredFontSize,
  ...rest
}: ColumnHeaderFilterIconProps) {
  const Icon = isFilterActive ? FilterAltIcon : FilterListIcon;

  const variantSx: SxProps<Theme> =
    variant === 'onPrimary'
      ? {
          fontSize: COLUMN_HEADER_FILTER_ICON_FONT_SIZE,
          color: isFilterActive ? SEARCE_COLORS.warning : SEARCE_COLORS.white,
        }
      : {
          fontSize: COLUMN_HEADER_FILTER_ICON_FONT_SIZE,
          color: isFilterActive ? SEARCE_COLORS.warning : 'currentColor',
        };

  return <Icon {...rest} sx={{ ...variantSx, ...sx }} />;
}
